// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"f93a8c1d","301":"3ddd9241","415":"c4e0d4a3","892":"96b1a0c8"}[chunkId] + ".css";
};